import { render, staticRenderFns } from "./e-navigation-links.vue?vue&type=template&id=68840a4d&scoped=true&lang=pug"
import script from "./e-navigation-links.vue?vue&type=script&lang=js"
export * from "./e-navigation-links.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68840a4d",
  null
  
)

export default component.exports